/* 
Common code for each of the views making up the provider page.
*/
import * as action from "@/store/providers/action-types";
import * as lcpAction from "@/store/levy-collection-providers/action-types";

export default {
  data() {
    return {
      arrivedFromListing: false,
      nextPageAction: action.LIST_NEXT_PAGE,
      previousPageAction: action.LIST_PREVIOUS_PAGE
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.arrivedFromListing = from.path.startsWith("/providers");
    });
  },
  computed: {
    providerId() {
      return parseInt(this.$route.params.providerId);
    },
    state() {
      return this.$store.state.providers.view;
    },
    loaded() {
      return this.state.loaded;
    },
    breadcrumbs() {
      return this.state.breadcrumbs;
    },
    lcpState() {
      return this.$store.state.levyCollectionProviders.listingForProvider;
    },
    provider() {
      return this.state.data;
    },
    levyCollectionProviders() {
      return this.lcpState.data;
    },
    loading() {
      return this.lcpState.loading || this.state.loading;
    },
    sector() {
      const he = this.provider.heApplicationStatus == "Approved";
      const vet = this.provider.vetApplicationStatus == "Approved";
      if (he && vet) {
        return "Dual sector";
      } else if (he) {
        return "HE";
      } else if (vet) {
        return "VSL";
      } else {
        return null;
      }
    },
    title() {
      return this.provider.name ? this.provider.name : "...";
    },
    subtitle() {
      return this.provider.providerCode ? this.provider.providerCode : "";
    },
    incompleteContacts() {
      return this.levyCollectionProviders.some(lcp => lcp.incompleteContacts);
    }
  },
  watch: {
    providerId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    async reload() {
      if ((!this.state.loaded && !this.state.loading) || this.state.providerId != this.providerId) {
        this.$store.dispatch(action.VIEW, this.providerId);
      }
      const ls = this.$store.state.levyCollectionProviders.listingForProvider;
      if ((!ls.loaded && !ls.loading) || ls.providerId != this.providerId) {
        this.$store.dispatch(lcpAction.LIST_FOR_PROVIDER, this.providerId);
      }
    }
  }
};
